// extracted by mini-css-extract-plugin
export default {"buttonState":"ButtonWithState_buttonState__heisZ","success-button":"ButtonWithState_success-button__lYRs7","failed-button":"ButtonWithState_failed-button__4UH-Q"};